export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10810.8328127a.jpg";